// extracted by mini-css-extract-plugin
export default {"onSelectedtab":"styles_onSelectedtab__Wevh1"};